import { Licenses } from "../Components/index";

export default Licenses;
